import { useEffect, useState, useCallback, useRef } from "react"
import { doc, onSnapshot, Firestore } from "firebase/firestore"

interface JobState {
  status: JobStatus | null
  errorMessage: string | null
  outputIds: string[]
}

export function useJobStatus(
  db: Firestore,
  projectId: string | undefined,
  jobId: string | null,
): JobState & { clearJob: () => void } {
  const [state, setState] = useState<JobState>({
    status: null,
    errorMessage: null,
    outputIds: [],
  })
  const jobIdRef = useRef(jobId)
  jobIdRef.current = jobId

  useEffect(() => {
    if (!projectId || !jobId) {
      setState({ status: null, errorMessage: null, outputIds: [] })
      return
    }

    const docRef = doc(db, 'projects', projectId, 'jobs', jobId)
    const unsub = onSnapshot(docRef, (snap) => {
      if (!snap.exists()) return
      const data = snap.data() as GenerationJob
      setState({
        status: data.status,
        errorMessage: data.error_message,
        outputIds: data.output_picture_ids || [],
      })
    })

    return () => unsub()
  }, [db, projectId, jobId])

  const clearJob = useCallback(() => {
    setState({ status: null, errorMessage: null, outputIds: [] })
  }, [])

  return { ...state, clearJob }
}
